module.exports = __webpack_public_path__ + "static/img/icon_servicios.5f015b93.svg";